module.exports = __webpack_public_path__ + "sk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sk.svg
// module id = 1060
// module chunks = 0